module.exports = __webpack_public_path__ + "img/51.8a0990a0.jpg";